import { INavItem } from "./Models/INavItem";
import { NavLink } from "react-router-dom";

const NavItem = (props: INavItem) => {
  return (
    <NavLink
      to={props.href}
      className={`hover:text-gray-400 transition-colors`}
      style={({ isActive }) => {
        return { color: isActive ? "#008DD2" : "" };
      }}
    >
      <div className="flex flex-col justify-center items-center py-2 px-2">
        {props.icon}
        <span className={"text-xs md:text-base"}>{props.title}</span>
      </div>
    </NavLink>
  );
};

export default NavItem;
